import * as React from 'react';
export const intercomSvg = React.forwardRef(function intercomSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0C1D34',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.317 17.006a.675.675 0 0 1-.41.62.661.661 0 0 1-.726-.145.675.675 0 0 1-.194-.475V11a.675.675 0 0 1 .41-.62.662.662 0 0 1 .726.145.675.675 0 0 1 .194.475v6.006Zm-.231 4.16c-.088.09-2.562 2.173-7.097 2.173-4.536 0-6.993-2.072-7.097-2.162a.661.661 0 1 1 .857-1.005c.038.028 2.248 1.839 6.234 1.839 3.986 0 6.213-1.822 6.235-1.838a.67.67 0 0 1 .94.071.665.665 0 0 1-.066.928l-.006-.005ZM8.655 11a.68.68 0 0 1 .446-.601.662.662 0 0 1 .693.16.675.675 0 0 1 .191.441v5.994a.675.675 0 0 1-.41.62.662.662 0 0 1-.725-.145.675.675 0 0 1-.195-.475V11Zm3.338-1.333a.68.68 0 0 1 .445-.602.662.662 0 0 1 .692.16.675.675 0 0 1 .193.442v8.889a.675.675 0 0 1-.41.62.662.662 0 0 1-.726-.145.675.675 0 0 1-.194-.475v-8.89Zm3.353-.334a.675.675 0 0 1 .41-.62.661.661 0 0 1 .726.145.675.675 0 0 1 .194.475V19a.675.675 0 0 1-.41.62.661.661 0 0 1-.726-.145.675.675 0 0 1-.194-.475V9.333Zm3.298.334a.672.672 0 0 1 .666-.672.662.662 0 0 1 .47.197.672.672 0 0 1 .195.475v8.889a.673.673 0 0 1-.41.62.663.663 0 0 1-.726-.145.675.675 0 0 1-.195-.475v-8.89ZM23.498 6H8.502a2.463 2.463 0 0 0-1.765.725A2.512 2.512 0 0 0 6 8.5v15c.003.666.268 1.303.737 1.775A2.482 2.482 0 0 0 8.502 26h14.996a2.46 2.46 0 0 0 1.763-.724c.469-.47.734-1.107.739-1.771V8.5a2.536 2.536 0 0 0-.736-1.772A2.484 2.484 0 0 0 23.504 6',
      fill: '#fff',
    }),
  );
});
intercomSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var intercom = {
  category: 'brand',
  colorable: false,
  name: 'intercom',
  svg: intercomSvg,
};
